<template>
  <div ref="banner" class="page-banner-container" :class="{ 'page-banner-container-hidden': !show, 'page-banner-container-contact': showContact }">
    <Banner :type="showContact ? 'standard' : 'accent'">
      <div class="banner-content">
        <template v-if="bannerNavigationLinks.length == 0">
          <div v-if="showContact" class="banner-links">
            <PageCountrySelect :country="country" :size="14" @change="onChangeCountry"></PageCountrySelect>
            <div class="link-divider">|</div>
            <div class="link-text"><a :href="$router.resolve({ name: 'helpCenter' }).href">Help Center</a></div>
            <div class="link-divider">|</div>
            <div class="link-text"><a :href="$router.resolve({ name: 'contact' }).href">+1-888-746-3455</a></div>
            <div class="link-divider">|</div>
            <div class="link-text"><a :href="$router.resolve({ name: 'tradeSignUp' }).href">Article for Trade</a></div>
          </div>
        </template>
        <template v-else>
          <div v-if="showContact" class="banner-links">
            <PageCountrySelect :country="country" :size="14" @change="onChangeCountry"></PageCountrySelect>
            <template v-for="bannerLink in bannerNavigationLinks" :key="bannerLink.name">
              <div class="link-divider">|</div>
              <div class="link-text"><a :href="bannerLink.url">{{bannerLink.name}}</a></div>
            </template>
          </div>
        </template>
        <div class="banner-message" v-if="message">
          <a :href="$router.resolve({ name: 'delivery' }).href"><span v-html="sanitize(message)"></span></a>
        </div>
        <div v-if="!showContact" class="banner-close">
          <a @click.prevent="close"><i class="af af-close"></i></a>
        </div>
      </div>
    </Banner>
  </div>
</template>
<script>
import smoothReflow from '@/plugins/smoothReflow';

import Banner from './Banner.vue';
import PageCountrySelect from './PageCountrySelect.vue';
import sanitize from '@/utils/sanitizer.js';

export default {
  components: {
    Banner,
    PageCountrySelect,
  },
  mixins: [smoothReflow],

  props: {
    bannerNavigationLinks: {
      type: Array,
      default: () => [],
    },
    message: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
    showContact: {
      type: Boolean,
      default: true,
    },
    country: {
      type: String,
      default: 'US',
    },
  },

  mounted() {
    this.$smoothReflow({
      el: this.$refs.banner,
      hideOverflow: true,
    });
  },

  methods: {
    close() {
      this.$emit('close');
    },

    chat() {
      this.$emit('chat');
    },

    onChangeCountry(country) {
      this.$emit('changeCountry', country);
    },
    sanitize
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';

.page-banner-container {
  z-index: 4;
  position: relative;

  &.page-banner-container-hidden {
    height: 0px;
    visibility: hidden;
  }

  &.page-banner-container-contact {
    display: none;
  }

  @media (min-width: $tablet-breakpoint) {
    &.page-banner-container-contact {
      display: block;
    }
  }

  .banner-content {
    display: flex;
    justify-content: space-between;
  }

  .link-text,
  .banner-message,
  .banner-close,
  .link-divider {
    font-size: var(--font-size-14);
    line-height: var(--line-height-14);
  }

  .banner-message {
    color: var(--grey-dark);
  }

  /* purgecss ignore */
  &:not(.page-banner-container-contact) {
    .banner-message {
      color: white;
    }

    .link-text,
    .banner-message,
    .banner-close,
    .link-divider {
      font-size: var(--font-size-14);
      line-height: var(--line-height-14);
    }
  }

  .banner-links,
  .banner-message {
    display: flex;
    align-items: center;
  }

  .banner-links {
    flex-wrap: wrap;
  }

  .banner-links {
    & > * {
      padding-right: 14px;
    }
  }
}
</style>
